import { TranslateService } from '@ngx-translate/core';
import { TranslateHelper } from './../../_helpers/translate-helper';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { BlockHeaderGroup } from '@app/_interfaces/block-header-group';
import { DirectionService } from '@app/_services/direction.service';
import * as _ from 'lodash';
import { SectionCardComponent } from './section-card/section-card.component';
import { OwlPreventClickDirective } from '../../shared/directives/owl-prevent-click.directive';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgClass, NgFor } from '@angular/common';


@Component({
    selector: 'app-block-sections',
    templateUrl: './block-sections.component.html',
    styleUrls: ['./block-sections.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgClass, CarouselModule, OwlPreventClickDirective, NgFor, SectionCardComponent]
})


export class BlockSectionsComponent implements OnInit, OnChanges {
    constructor(public translateHelper: TranslateHelper, private direction: DirectionService, private translate: TranslateService
    ) { }
    @Input() sections: any = {}
    @Input() rows = 1;
    @Input() loading = false;

    columns: any[][] = [];

    @Input() name;
    @Input() layout: 'grid-4' | 'grid-4-sm' | 'grid-5' | 'horizontal' | 'custom' = 'custom';
    @Input() itemLayout: 'grid-sm' | 'grid-nl' | 'grid-lg' | 'list' | 'horizontal' | null = null;


    //@Output() groupChange: EventEmitter<BlockHeaderGroup> = new EventEmitter();


    carouselDefaultOptions: any = {
        lazyLoad: true,
        items: 4,
        margin: 14,
        nav: false,
        dots: false,
        loop: true,
        skip_validateItems: true,
        stagePadding: 1,
        rtl: this.direction.isRTL()
    };

    carouselOptionsByLayout: any = {

        'custom': {
            responsive: {
                1210: { items: 5, margin: 14 },
                910: { items: 4, margin: 12 },
                730: { items: 4, margin: 10 },
                590: { items: 3, margin: 10 },
                400: { items: 2, margin: 10 },
                0: { items: 2 }
            }
        }
    };

    carouselOptions;

    ngOnInit(): void {
        this.carouselOptions = Object.assign({}, this.carouselDefaultOptions, this.carouselOptionsByLayout[this.layout]);
    }

    ngOnChanges(changes: SimpleChanges): void {

        const properties = Object.keys(changes);

        if (properties.includes('products') || properties.includes('row')) {
            this.columns = [];

            if (this.sections && this.rows > 0) {
                const products = this.sections.slice();

                while (products.length > 0) {
                    this.columns.push(products.splice(0, this.rows));
                }
            }
        }
    }

    groupChange(group): void {
        //this.loading = true;
        this.sections = this.sections.splice(0, 1)
    }
}
